/*
 * @Author: liuyongjun
 * @Date: 2023-02-07 09:47:12
 * @LastEditors: liuyongjun
 * @LastEditTime: 2023-02-07 09:51:22
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: \ejx-web\src\router\module\goods-module-map.js
 */
const goodsRecommend = r =>
  require.ensure([], () => r(require('@/views/goods-module/goods-recommend.vue'), 'goodsRecommend'))
const goodsSearch = r => require.ensure([], () => r(require('@/views/goods-module/goods-search.vue'), 'goodsSearch'))
const goodsRecommendDetail = r =>
  require.ensure([], () => r(require('@/views/goods-module/goods-recommend-detail.vue'), 'goodsRecommendDetail'))
const flightDynamicsSearch = r =>
  require.ensure([], () => r(require('@/views/flightDynamics/flight-dynamics-search.vue'), 'flightDynamicsSearch'))
const flightDynamicsList = r =>
  require.ensure([], () => r(require('@/views/flightDynamics/flight-dynamics-list.vue'), 'flightDynamicsList'))
const flightDynamicsDetail = r =>
  require.ensure([], () => r(require('@/views/flightDynamics/flight-dynamics-detail.vue'), 'flightDynamicsdetail'))
// 路由组件注册
const router = [
  {
    path: '/goodsRecommend',
    name: 'goodsRecommend',
    meta: {
      title: '精品推荐'
    },
    component: goodsRecommend
  },
  {
    path: '/goodsSearch',
    name: 'goodsSearch',
    meta: {
      title: '精品推荐'
    },
    component: goodsSearch
  },
  {
    path: '/goodsRecommendDetail/:id',
    name: 'goodsRecommendDetail',
    component: goodsRecommendDetail
  },
  // 航班动态查询
  {
    path: '/flightDynamicsSearch',
    name: '/flightDynamicsSearch',
    component: flightDynamicsSearch,
    meta: {
      keepAlive: true
    }
  },
  // 航班动态列表
  {
    path: '/flightDynamicsList',
    name: '/flightDynamicsList',
    component: flightDynamicsList
  },
  // 航班动态详情
  {
    path: '/flightDynamicsDetail',
    name: '/flightDynamicsDetail',
    component: flightDynamicsDetail
  }
]
export default router
